import { weiToEthNumber } from '@/lib/launchpad/wei'
import type { Project } from '@/lib/mockData'
import { creatorPctFromLp } from '@/lib/protocol'
import { getPresaleStatus } from '@/lib/presale/math'
import type { SimPresale } from '@/lib/presale/types'

export function simPresaleToProject(presale: SimPresale): Project {
  const raised = weiToEthNumber(presale.raisedWei)
  const softCap = weiToEthNumber(presale.softCapWei)
  const hardCap = weiToEthNumber(presale.hardCapWei)
  return {
    id: presale.id,
    type: 'presale',
    name: presale.name,
    ticker: presale.ticker,
    category: presale.category,
    tagline: presale.tagline,
    description: presale.description,
    imageUrl: presale.imageUrl,
    status: getPresaleStatus(presale),
    raised,
    goal: hardCap,
    participants: presale.participants,
    startsAt: presale.startsAt,
    endsAt: presale.endsAt,
    website: presale.website,
    twitter: presale.twitter,
    youtube: presale.youtube,
    telegram: presale.telegram,
    discord: presale.discord,
    tiktok: presale.tiktok,
    facebook: presale.facebook,
    instagram: presale.instagram,
    minContribution: weiToEthNumber(presale.minContributionWei),
    maxContribution: weiToEthNumber(presale.maxContributionWei),
    supply: weiToEthNumber(presale.totalSupplyWei ?? 0n),
    maxSupply: weiToEthNumber(presale.totalSupplyWei ?? 0n),
    softCap,
    hardCap,
    lpPct: presale.lpPct,
    tokensPerEth: weiToEthNumber(presale.tokensPerEthWei ?? 0n),
    listingRate: weiToEthNumber(presale.listingRateWei ?? presale.tokensPerEthWei ?? 0n),
    teamPct: creatorPctFromLp(presale.lpPct),
    quote: 'eth',
    source: 'sim',
    creatorAddress: presale.creatorAddress,
    contractAddress: presale.contractAddress,
    tokenAddress: presale.tokenAddress,
    shareSlug: presale.shareSlug,
  }
}
